common.View.create('habitats.website.modules.partners.Block', {

    onDOMLoad() {
        this.initDropdown();
    },

    initDropdown()
    {
        this.element.find('select').change((event) => {
            let optionValue = $(event.currentTarget).val(),
                url = window.location.href.split("?")[0];

            window.location = url + '?theme=' + optionValue + '#partners';
        });
    }
});